import Singleton from '../clazz/Singleton';

export class EventController extends Singleton{

	constructor(options) {
		super(options);
		this._listeners = {};
	}

	addEventListener(type, listener){

		const listeners = this._listeners;
		listeners[type] = listener;

	}

	removeEventListener(type) {
		if(this._listeners[type] !== undefined){
			delete this._listeners[type];
		}
	};

	dispatchEvent(event){
		let listeners = this._listeners;
		let listener = listeners[event.type];
		if ( listener ) {
			event.target = this;
			listener.call(this, event);
		}

	}

}